import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router";
import MainPage from "./Containers/MainPage";
import Test from "./Containers/Test";
import IntesivePage from "./Containers/IntesivePage";
import UserStore from "./store/UserStore";
import SPaymentWIdget from "./Containers/SPaymentWIdget";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ContactOffer from "./Containers/contractOffer/inde";
import PaymentForm from "./Containers/PaymentForm";
import InstallmentInfo from "./Containers/InstallmentInfo";
import TestUserBanner from "./Components/TestUserBanner";

function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <BrowserRouter>
      <UserStore>
        <TestUserBanner />
        <Routes>
          <Route path="/" exact element={<MainPage />} />
          <Route path="/test" exact element={<Test />} />
          <Route path="/intensive" exact element={<IntesivePage />} />
          <Route path="/payment" exact element={<PaymentForm />} />
          <Route path="/contract-offer" exact element={<ContactOffer />} />
          <Route path="/installment" exact element={<InstallmentInfo />} />
          <Route
            path="/successful-payment"
            exact
            element={<SPaymentWIdget />}
          />
        </Routes>
      </UserStore>
    </BrowserRouter>
  );
}

export default App;
